import React from 'react'
import { ReactComponent as TrashIcon } from 'presentation/assets/icons/trash-icon.svg'
import CardNew from 'presentation/shared/components/CardNew'
import DividerNew from 'presentation/shared/components/DividerNew'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import { ProviderV2Props } from 'presentation/contexts/surgical-order-v2/types'
import { DataSource } from 'common/enum/data-source'
import * as S from './styles'
import { Item } from '../components/styles'
import { DeleteIconButton, StyledCheckbox } from '../../components/styles'
import { AddItemButton, EmptyListState, SectionHeader } from '../components'

type Props = {
  initialRows: ProviderV2Props[]
  onDelete: (providerCode: string) => void
  onToggleSelection?: (providerCode: string) => void
  onAddProvider?: () => void
  showAddButton?: boolean
}

function ProvidersList({
  initialRows,
  onDelete,
  onToggleSelection,
  onAddProvider,
  showAddButton = false
}: Props) {
  const hospitalRows = initialRows.filter(
    (row) => row.source === DataSource.TEMPLATE
  )
  const doctorRows = initialRows.filter(
    (row) => row.source === DataSource.DOCTOR
  )

  const isFromHospitalTemplate = (providerId: string) => {
    return hospitalRows.some((row) => row.code === providerId)
  }

  const sections = [
    {
      title: 'Histórico de fornecedores aprovados',
      rows: hospitalRows,
      disableDelete: true
    },
    {
      title: 'Inclusões do médico',
      rows: doctorRows,
      disableDelete: false
    }
  ]

  if (initialRows.length === 0) {
    return (
      <EmptyListState
        message="Nenhum fornecedor foi adicionado ainda"
        showAddButton={showAddButton}
        onAdd={onAddProvider}
        addLabel="Indicar outro fornecedor"
      />
    )
  }

  return (
    <CardNew
      background="neutral25"
      padding="1rem"
      style={{ borderRadius: '8px' }}
    >
      {sections.map((section, sectionIndex) => {
        if (section.rows.length === 0) return null

        return (
          <S.ProviderSection key={`section-${sectionIndex}`}>
            <SectionHeader title={section.title} />
            {section.rows.map((row, rowIndex) => {
              const isLastRow = rowIndex === section.rows.length - 1
              const isCheckboxDisabled = !isFromHospitalTemplate(row.code)

              return (
                <div key={row.code}>
                  <Item>
                    <S.ProviderContent>
                      <StyledCheckbox
                        checked={row.is_selected || false}
                        onChange={() => onToggleSelection?.(row.code)}
                        disabled={isCheckboxDisabled}
                      />
                      <S.JustificationColumn>
                        {section.disableDelete ? (
                          <HeadingNew
                            size="xxxsmall"
                            color="textPrimary"
                            weight="semiBold"
                            as="div"
                          >
                            {row.name}
                          </HeadingNew>
                        ) : (
                          <>
                            <HeadingNew
                              size="xxxsmall"
                              color="neutral900"
                              weight="bold"
                              as="div"
                            >
                              {row.name}
                            </HeadingNew>
                          </>
                        )}
                        <SupportTextNew
                          size="xxxsmall"
                          weight="semiBold"
                          color="neutral900"
                          as="div"
                          style={{ flex: 1 }}
                        >
                          {row.reason}
                        </SupportTextNew>
                      </S.JustificationColumn>
                      <DeleteIconButton
                        size="small"
                        onClick={() => onDelete(row.code)}
                        style={{ marginLeft: 'auto' }}
                      >
                        <TrashIcon width={18} height={18} />
                      </DeleteIconButton>
                    </S.ProviderContent>
                  </Item>
                  {(!isLastRow || (isLastRow && section.disableDelete)) && (
                    <DividerNew marginTop="0.5rem" marginBottom="0.5rem" />
                  )}
                </div>
              )
            })}
          </S.ProviderSection>
        )
      })}

      {showAddButton && (
        <AddItemButton
          onClick={onAddProvider}
          label="Indicar outro fornecedor"
        />
      )}
    </CardNew>
  )
}

export default ProvidersList
